import { useEffect, useRef, useState } from 'react';

export const useInitialPageFetch = <T extends unknown>(fetch: () => Promise<{ data: T }>) => {
  const cancelFetch = useRef(false);
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    (async () => {
      const res = await fetch();

      if (cancelFetch.current) return;
      setData(res.data);
    })();

    return () => {
      cancelFetch.current = true;
    };
  }, []);

  return data;
};
